{
  "locale": "English",
  "sidebar": {
    "title": "Data sharing request",
    "issuanceTitle": "Request to add data",
    "authenticationTitle": "Authentication request",
    "description": "{clientName} is requesting verified personal data from your identity app. Review the details below and approve or decline this request in your identity app.",
    "issuanceDescription": "{clientName} is adding verified data to your identity app. Review the details below and confirm in your identity app whether you wish to accept.",
    "authenticationDescription": "{clientName} wants to authenticate with your identity app.",
    "descriptionFallback": "A service is requesting verified personal data from your identity app. Review the details below and approve or decline this request in your identity app.",
    "issuanceDescriptionFallback": "A service is adding verified data to your identity app. Review the details below and confirm in your identity app whether you wish to accept.",
    "authenticationDescriptionFallback": "A service wants to authenticate with your identity app.",
    "stepsTitle": "Steps to complete",
    "stepShareData": "Share data with {clientName}",
    "stepAuthenticate": "Authenticate for {clientName}",
    "stepReceiveData": "Receive data from {clientName}",
    "stepGeneric": "Complete the required steps",
    "defaultClientName": "the service",
    "requestedDataTitle": "The following data is being requested",
    "issuedDataTitle": "The following data will be issued",
    "reviewNotice": "You will review and approve the exact data in your identity app before anything is shared.",
    "issuanceReviewNotice": "You will review and approve the exact data in your identity app before anything is added.",
    "indeterminateHint": "The requested data will be visible after you have selected an identity app",
    "terms": "Terms",
    "termsLink": "Terms",
    "privacyLink": "Privacy Policy",
    "showAll": "Show all",
    "purposeStatementTitle": "Why your data is needed",
    "retentionPolicyTitle": "How your data is handled"
  },
  "footer": {
    "powered": "Powered by",
    "terms": "Terms"
  },
  "topBar": {
    "openMenu": "Open menu",
    "closeMenu": "Close menu",
    "help": "Help",
    "language": "Language"
  },
  "app": {
    "error": "Error",
    "loadingTitle": "Loading",
    "loadingHint": "One moment please"
  },
  "language": {
    "en": "English",
    "nl": "Nederlands",
    "de": "Deutsch",
    "fr": "Français",
    "sv": "Svenska",
    "es": "Español",
    "search": "Search",
    "noResults": "No results"
  },
  "init": {
    "title": "Processing request",
    "hint": "Setting up your session"
  },
  "pairing": {
    "title": "Preparing next step",
    "hint": "Setting up your session",
    "codeLabel": "Verify the following code in your identity app",
    "confirm": "Confirm pairing"
  },
  "waitingForPresentation": {
    "title": "Continue in your identity app",
    "hint": "Please check your identity app to review and approve the request"
  },
  "agentStart": {
    "title": "Continue in {appName}",
    "subtitle": "To securely share your data, scan this QR code with {appName} to review and approve the request.",
    "issuanceSubtitle": "To securely receive the data, scan this QR code with {appName} to review and approve the request.",
    "step1": "Open {appName}",
    "step2": "Click the scanner icon",
    "step3": "Scan this QR code",
    "changeApp": "Change identity app",
    "installInstructions": "Installation instructions",
    "cancel": "Cancel",
    "needHelp": "Need help?",
    "redirectSubtitle": "Click the button below to open {appName} and approve the request.",
    "issuanceRedirectSubtitle": "Click the button below to open {appName} and approve the request.",
    "redirectButton": "Continue",
    "mobileSubtitle": "To securely share your data, continue in {appName} to review and approve the request.",
    "issuanceMobileSubtitle": "To securely receive the data, continue in {appName} to review and approve the request.",
    "openApp": "Open {appName}",
    "showQr": "Show QR code"
  },
  "done": {
    "disclosure": {
      "title": "Data is successfully shared",
      "subtitle": "The page will automatically close in a few seconds.",
      "subtitleCloseTab": "Data successfully shared. Feel free to close this page."
    },
    "issuance": {
      "title": "Data successfully received",
      "subtitle": "The page will automatically close in a few seconds.",
      "subtitleCloseTab": "Data successfully received. Feel free to close this page."
    },
    "redirecting": "Redirecting...",
    "completeRedirect": "Complete & redirect",
    "redirectFailed": "Automatic redirect didn't work. Tap below to continue.",
    "subtitleWebhookDelivered": "Verification complete."
  },
  "abort": {
    "cancel": {
      "title": "Process stopped",
      "subtitle": "You chose to stop the process. You can restart at any time."
    },
    "techFail": {
      "title": "Something went wrong",
      "subtitle": "We could not complete the process due to a technical issue."
    },
    "timeout": {
      "title": "Session expired",
      "subtitle": "This session ended after a period of inactivity. To continue, close this page and restart the process."
    },
    "networkLoss": {
      "title": "Connection lost",
      "subtitle": "Your internet connection was interrupted. Please check your connection and try again."
    },
    "backendDowntime": {
      "title": "Service temporarily unavailable",
      "subtitle": "The service is currently undergoing maintenance. Please try again later."
    },
    "appUnavailable": {
      "title": "Identity app unavailable",
      "subtitle": "We could not connect to the selected identity app. The app may be temporarily unavailable. You can try a different identity app or try again later."
    },
    "deliveryModeMismatch": {
      "title": "Configuration error",
      "subtitle": "This verification flow is not configured for this delivery mode. Please check the flow settings or contact support."
    },
    "flowNotConfigured": {
      "title": "Flow not configured",
      "subtitle": "This verification flow has not been fully configured. Please configure redirect URIs or webhook delivery in the flow settings."
    },
    "parentOriginNotAllowed": {
      "title": "Origin not allowed",
      "subtitle": "The embedding application's origin is not in the list of allowed origins for this flow."
    },
    "selectDifferentApp": "Select different identity app",
    "confirmTitle": "Stop process?",
    "confirmMessage": "Are you sure you want to stop? You can restart at any time if you want to continue later.",
    "confirmCancel": "Cancel",
    "confirmStop": "Stop process",
    "goBack": "Go back",
    "leave": "Leave",
    "closePage": "Close page",
    "restart": "Restart",
    "retry": "Retry"
  },
  "appPicker": {
    "title": "Supported identity apps",
    "subtitle": "The following identity apps can be used to review and approve the request",
    "searchPlaceholder": "Search...",
    "sectionLastUsed": "Last used",
    "sectionRecommended": "Recommended",
    "sectionAZ": "A-Z",
    "noResults": "No apps match your search",
    "filterTitle": "Filter by country",
    "filterClear": "Clear all",
    "filterDone": "Done"
  },
  "faq": {
    "helpQuestion": "Question",
    "moreHelp": "More help",
    "close": "Close",
    "whatAreWallets": {
      "title": "What are identity apps?",
      "body": "An identity app lets you control your own data. You decide what you share, with whom, and when. Your data is retrieved from a verified issuer and stored in the app along with a digital signature that guarantees its accuracy.\n\nWhen you share data with a third party, the digital signature is included so they can verify it is authentic. Your data is usually stored only on your phone and can easily be retrieved again if needed.\n\nAlways be aware that it is your responsibility to carefully choose with whom you share your data."
    },
    "whyNotSupported": {
      "title": "Why is my identity app not supported?",
      "body": "Your specific identity app may not be available because the receiving party or our platform does not currently support it. We are constantly working to expand our range of supported apps.\n\nIf your app is not listed, you can always install and use one of the other supported identity apps."
    },
    "howDataProtected": {
      "title": "How is my data protected?",
      "body": "Identity apps give you full control over who you share your data with and when. They usually provide an overview of what you have shared, with whom, and when.\n\nVer.iD sends your data directly to the receiving party and only checks that it was delivered correctly. All data is processed in accordance with the General Data Protection Regulation (GDPR). The receiving party applies their own data protection rules and will communicate these to you.\n\nAlways be aware that it is your responsibility to carefully choose with whom you share your data."
    },
    "howObtainData": {
      "title": "How can I put data in my app?",
      "body": "Each identity app has its own way of collecting data. Most apps have a button to add data, though in some cases there may be costs involved.\n\nFollow the instructions in your app to collect data securely. You may be redirected to government websites or asked to scan documents like passports or driving licenses.\n\nIf you cannot find a way to add the right data, check the app's documentation or contact the vendor. You can also try a different identity app."
    },
    "whyRedirection": {
      "title": "Why am I being redirected?",
      "body": "Some identity apps require a redirect to their own website so your data is shared in compliance with their standards, while maintaining the best experience in an environment you trust.\n\nAfter successfully sharing, you will be redirected back to Ver.iD where your data awaits your confirmation before being sent to the receiving party. A digital receipt is usually available in your identity app.\n\nIf the process fails or is cancelled, you will be redirected back and may have the option to retry."
    }
  },
  "dataReview": {
    "title": "Please review the data",
    "subtitleDisclosure": "Before you share, take a moment to review the data that will be shared with {clientName}.",
    "subtitleIssuance": "Before you accept, take a moment to review the data you will receive from {clientName}.",
    "issuedBy": "Data issued by",
    "attribute": "Attribute",
    "value": "Value",
    "cancel": "Cancel",
    "acceptShare": "Accept",
    "acceptReceive": "Accept",
    "unknownClient": "the service",
    "loadingNames": "Loading data names...",
    "errorLoadingNames": "Could not load data names. Please try again."
  },
  "mobileFlowStart": {
    "startVerification": "Continue",
    "selectApp": "Select identity app"
  },
  "requestedDataModal": {
    "title": "Requested data",
    "subtitle": "You will review and approve this request in your identity app.",
    "attribute": "Attribute",
    "description": "Description",
    "issuedBy": "Data issued by",
    "close": "Close"
  },
  "demo": {
    "title": "Demo environment",
    "description": "You are using an interactive demo of Ver.iD. This environment is intended for demonstration purposes only."
  },
  "installInstructions": {
    "title": "Install {appName}",
    "subtitle": "Visit the App Store or Play Store on your phone to install {appName} identity app. Scan the code to directly open the store page to install the app.",
    "close": "Close",
    "unavailableTitle": "Instructions not available",
    "unavailableBody": "Sorry, we don't have any installation instructions for this app available at the moment. Try to manually search for the app in the app store to continue."
  }
}
